import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-register-user")
class RegisterUser extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <form class="${style.registerUser__form}" id="registerForm">
        <m-name></m-name>
        <m-email></m-email>
        <m-password></m-password>
        <m-class data-school="${this.dataset.school}"></m-class>
        <button class="${style.registerUser__save}" type="submit">Cadastrar</button>
      </form>
    `;
  }

  @on.submit("form")
  @filter.prevent
  @filter.validity
  @filter.formData
  async [trait.onSubmit]({ email, name, password, class: class_id }) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: { data: { name } },
    });

    if (error) {
      alert(error.message);
      return this;
    }

    await supabase.from("user").insert([
      {
        id: data.user.id,
        name,
        email,
      },
    ]);

    await supabase.from("team").insert([
      {
        user_id: data.user.id,
        school_id: this.dataset.school,
        type_id: "39f157a2-e8e8-4302-8ca0-0fa8743e2409",
        class_id,
      },
    ]);

    alert("Usuário cadastrado com sucesso!");
    location.reload();

    return this;
  }
}

export default RegisterUser;
